import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Messages Redux States
import { CHANGE_DISPLAY_NAME } from "./actionTypes";
import { changeDisplayNameError, changedDisplayName } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* changeDisplayName({ payload: { chatId, chatDisplayName } }) {
  try {
    const response = yield call(
      axios.patch,
      `/display-name?${chatId ? "&id=" + chatId : ""}`,
      { display_name: chatDisplayName }
    );

    if (response.status === 200) {
      yield put(
        changedDisplayName({
          chatId: chatId,
          chatDisplayName: chatDisplayName,
        })
      );
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Change display name error";
    yield put(
      changeDisplayNameError({
        action: "change_display_name",
        message: message,
      })
    );
  }
}

export function* watchChangeDisplayName() {
  yield takeEvery(CHANGE_DISPLAY_NAME, changeDisplayName);
}
function* authSaga() {
  yield all([fork(watchChangeDisplayName)]);
}

export default authSaga;
